<template>
  <div class="footer">
    <div class="content">
      <div class="left">
          <img :src="`${url}/home/logo.png`" alt="">
          <div class="phone">电话：081-60329867</div>
          <div class="email">邮箱：potqqhq36733@etang.com</div>
      </div>
      <div class="right">
        <div class="wrap">
          <div class="title">认识小鹿</div>
          <div class="list-wrap">
            <div class="list-item" v-for="item in tab1" :key="item">{{item}}</div>
          </div>
        </div>
        <div class="wrap">
          <div class="title">常见问题</div>
          <div class="list-wrap">
            <div class="list-item" v-for="item in tab2" :key="item">{{item}}</div>
          </div>
        </div>
         <div class="wrap">
          <div class="title">用户俱乐部</div>
          <div class="list-wrap">
            <div class="list-item" v-for="item in tab3" :key="item">{{item}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="name">
      杭州小鹿柯基网络科技有限公司
    </div>
  </div>
</template>
<script setup>
import {url} from '@/api'
const tab1 = ['公司介绍','加入我们']
const tab2 = ['宣传运营','产品开发','登录相关','服务相关','备案相关','计费相关']
const tab3 = ['用户中心','解决方案']
</script>
<style lang="scss" scoped>
.footer{
  height: 372px;
  background: #212121;
  .content{
    display: flex;
    padding: 80px 272px 0;
    justify-content: space-between;
    .left{
      img{
        width: 184px;
        height: 63px;
      }
      div{
        font-size: 16px;
        line-height: 20px;
        color: #fff;
      }
      .phone{
        margin: 27px 0 17px;
      }
    }
    .right{
      display: flex;
      color: #fff;
      .wrap{
        margin-left: 80px;
        .title{
          font-size: 18px;
          margin-bottom: 25px;
        }
        .list-item{
          font-size: 16px;
          line-height: 20px;
          margin-bottom: 6px;
        }
      }
    }
  }
  .name{
    color: #fff;
    font-size: 16px;
    text-align: center;
    margin-top: 32px;

  }
}
</style>
